import{Range as e}from"./Range.mjs";class t extends e{static of(e,r,s){return new t([e,r],s)}replaceRequired(e){return new t(this.itemsAttributes,e)}}export{t as StringRange};
